module.exports = { id: "twitter", url: "/build/app/img/symbols.svg#twitter", viewBox: "", toString: function() { return this.url; } };